import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Header from '../components/Header';
import OptionRow from '../../Profile/OptionRow';
import ClubStats from '../../Units/ClubStats';
import clubSettings from '../../../config/clubSettings';
import configs from '../../../config/config';
import { clubDataRequest } from '../../../store/actionCreators/club';
import {
  getClubChipBalance,
  getCurrentClub,
  getRoleInCurrentClub,
} from "../../../store/selectors";
import '../../../assets/stylesheets/ClubSlide/ClubSettings.scss';


const ClubSettings = () => {
    // const stats = useSelector(getAccountStats);
    const { id: clubId } = useParams();
    const clubData = useSelector(getCurrentClub);
    const clubChipBalance = useSelector(getClubChipBalance);
    const roleInClub = useSelector(getRoleInCurrentClub);
    const menuItems = clubSettings[roleInClub];

    const dispatch = useDispatch();
    const [rowParams, setRowParams] = useState({
      buyLevel: {},
      clubChips: {},
      disband: { clubId }
    });

    useEffect(() => {
      if (!!clubChipBalance && !!clubData) {
        setRowParams({
          ...rowParams,
          buyLevel: { buyLevel: clubData.level, leftDays: clubData.levelExpDays },
          clubChips: { clubName: clubData.clubName, clubChips: clubChipBalance }
        });
      }
    }, [clubData.level, clubChipBalance]);

    useEffect(() => {
      dispatch(clubDataRequest(clubId, null, null, roleInClub === 'agent'));
    }, []);

    return (
        <div className="clubSettings clubPage">
            <Header title="options" to={`/club/${clubId}`} />
            <div className="subheader">
              <ClubStats alwaysExpanded className="gameInfoContent--settings" />
            </div>
            <div className="settingsContainer">
              {menuItems.map((item, index) =>
                <OptionRow to={`/club/${clubId}/${item}`} key={index} option={item} section="options" params={rowParams[item] || ''} />
              )}
            </div>
        </div>
    );
};

export default ClubSettings;
